import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function MerciSatisfactionFinPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-indigo-50 flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl shadow-2xl p-8 text-center">
          <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-purple-100 to-pink-100 rounded-full flex items-center justify-center">
            <i className="ri-checkbox-circle-line text-5xl text-purple-600"></i>
          </div>

          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            Merci pour votre retour !
          </h1>

          <p className="text-gray-600 mb-8">
            Votre questionnaire de fin de formation a été enregistré avec succès. Vos réponses nous aideront à améliorer nos formations.
          </p>

          <div className="space-y-3">
            <button
              onClick={() => navigate('/')}
              className="w-full py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all"
            >
              Retour à l'accueil
            </button>
          </div>

          <p className="text-sm text-gray-500 mt-6">
            Redirection automatique dans 5 secondes...
          </p>
        </div>
      </div>
    </div>
  );
}
